import { useCallback, useContext, useEffect, useState } from "react";
import { MdNotes, MdOutlineKeyboardArrowDown } from "react-icons/md";
import NavWrapper from "gamfi/sections/Header/v1/Header.style";
import Button from "gamfi/components/button";
import connectIcon from "gamfi/assets/images/icons/connect.png";
// import walletIcon1 from "gamfi/assets/images/icons/pancake.png";
// import walletIcon2 from "gamfi/assets/images/icons/uniswap.png";
// import walletIcon3 from "gamfi/assets/images/icons/market.png";
// import walletIcon4 from "gamfi/assets/images/icons/gate.png";
import MobileMenu from "./MobileMenu";
import { navigation } from "data/navigation";

import MEnergy from "assets/header/header.png";
import { defaults, MetaverseContext } from "blockchain/provider";
import { Token } from "blockchain/token";
import { metaverse } from "data/metaverse";

import antimatterAbi from "artifacts/contracts/tokens/AntiMatter.sol/AntiMatter.json";
import matterAbi from "artifacts/contracts/tokens/Matter.sol/Matter.json";
import energyAbi from "artifacts/contracts/tokens/Energy.sol/Energy.json";

import { useHandleNavigate } from "utils/hooks";
import { addressShortener } from "utils/token";
import { useAccount, useSigner, useDisconnect } from "wagmi";

import { useWeb3Modal } from "@web3modal/react";

const Header = () => {
  const navigate = useHandleNavigate();

  const { open } = useWeb3Modal();
  const { disconnect } = useDisconnect();
  const { address, isConnected } = useAccount();
  const { data: signer, isLoading } = useSigner();

  const { setEnergy, setAntimatter, setMatter } = useContext(MetaverseContext);

  const handleDisconnect = useCallback(
    (e: any) => {
      e.preventDefault();
      disconnect();
    },
    [disconnect]
  );

  const handleOpen = useCallback(
    (e: any) => {
      e.preventDefault();
      open();
    },
    [open]
  );

  useEffect(() => {
    if (isConnected && !isLoading && signer) {
      console.log(`use web3modal provider`);

      setAntimatter(new Token(signer, metaverse.antimatter, antimatterAbi.abi));
      setMatter(new Token(signer, metaverse.matter, matterAbi.abi));
      setEnergy(new Token(signer, metaverse.energy, energyAbi.abi));
    } else {
      console.log(`use infura node`);

      setAntimatter(defaults.antimatter);
      setMatter(defaults.matter);
      setEnergy(defaults.energy);
    }
  }, [isConnected, isLoading, signer, setEnergy, setAntimatter, setMatter, address]);

  const [isMobileMenu, setMobileMenu] = useState(false);
  const handleMobileMenu = useCallback(() => {
    setMobileMenu(!isMobileMenu);
  }, [setMobileMenu, isMobileMenu]);

  useEffect(() => {
    const header = document.getElementById("navbar");
    const handleScroll = () => {
      if (window.pageYOffset > 50) {
        header?.classList.add("sticky");
      } else {
        header?.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("sticky", handleScroll);
    };
  }, []);

  return (
    <NavWrapper className="gamfi_header" id="navbar">
      <div className="container">
        {/* Main Menu Start */}
        <div className="gamfi_menu_sect">
          <div className="gamfi_menu_left_sect">
            <div className="logo">
              <a href="/" onClick={navigate(`/`)}>
                <img src={MEnergy} alt="gamfi nft logo" />
              </a>
            </div>
          </div>
          <div className="gamfi_menu_right_sect gamfi_v1_menu_right_sect">
            <div className="gamfi_menu_list">
              <ul>
                {/* menu  */}
                {navigation?.map((menu, i) => (
                  <li key={i}>
                    <a href={menu.url} onClick={navigate(menu.url)}>
                      {menu.title} {menu.subMenus?.length > 0 && <MdOutlineKeyboardArrowDown />}
                    </a>

                    {/* if has subMenu and length is greater than 0 */}
                    {/* {menu.subMenus.length > 0 && (
                      <ul className="sub_menu_list">
                        {menu.subMenus.map((subMenu, i) => (
                          <li key={i}>
                            <a href={subMenu.url}>
                              {subMenu.title}{" "}
                              {subMenu?.subMenuChilds?.length > 0 && (
                                <MdOutlineKeyboardArrowRight />
                              )}
                            </a>

                            if subMenu child has menu child
                            {subMenu?.subMenuChilds?.length > 0 && (
                              <ul className="sub_menu_child_list">
                                {subMenu?.subMenuChilds?.map((subChild, i) => (
                                  <li key={i}>
                                    <a href={subChild.url}>
                                      {" "}
                                      {subChild.title}{" "}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    )} */}
                  </li>
                ))}
              </ul>
            </div>
            <div className="gamfi_menu_btns">
              <button className="menu_btn" onClick={() => handleMobileMenu()}>
                <MdNotes />
              </button>

              {/* <div className="wallet_btn">
                Buy token <MdOutlineKeyboardArrowDown />
                <div className="wallet_token_list">
                  <a href="#">
                    {" "}
                    <img src={walletIcon1} alt="icon" /> PancakeSwap{" "}
                  </a>
                  <a href="#">
                    {" "}
                    <img src={walletIcon2} alt="icon" /> UniSwap
                  </a>
                  <a href="#">
                    {" "}
                    <img src={walletIcon3} alt="icon" /> CoinMarketCap
                  </a>
                  <a href="#">
                    {" "}
                    <img src={walletIcon4} alt="icon" /> Gate.io
                  </a>
                </div>
              </div> */}

              {isConnected && address ? (
                <Button href="#" sm variant="white" className="connect_btn" onClick={handleDisconnect}>
                  {addressShortener(address)}
                </Button>
              ) : (
                <Button href="#" sm variant="white" className="connect_btn" onClick={handleOpen}>
                  <img src={connectIcon} alt="icon" />
                  Connect
                </Button>
              )}
            </div>
          </div>
        </div>
        {/* <!-- Main Menu END --> */}
        {/* <!-- mobile menu --> */}
        {isMobileMenu && <MobileMenu mobileMenuhandle={handleMobileMenu} />}
      </div>
    </NavWrapper>
  );
};

export default Header;
